import {fromEvent} from 'rxjs';
import * as qs from 'app/lib/helperjs';
import {
    CONTENT_ATTRIBUTE as TAB_CONTENT_ATTRIBUTE,
    TAB_ATTRIBUTE as TAB_BUTTON_ATTRIBUTE,
} from '../ui/tab';
import {
    CONTENT_ATTRIBUTE as ACC_CONTENT_ATTRIBUTE,
    BUTTON_ATTRIBUTE as ACC_BUTTON_ATTRIBUTE,
    ACTIVE_CLASS as ACC_ACTIVE_CLASS,
    setWindowHashLocation
} from '../ui/accordion';
import {StringHelper} from 'app/lib/stringHelper';

const tabContents = qs.querySelectorAll(`[${TAB_CONTENT_ATTRIBUTE}]`);
const tabButtons = qs.querySelectorAll(`[${TAB_BUTTON_ATTRIBUTE}]`);

const accContents = qs.querySelectorAll(`[${ACC_CONTENT_ATTRIBUTE}]`);
const accButtons = qs.querySelectorAll(`[${ACC_BUTTON_ATTRIBUTE}]`);

export const Faq = () => {
    if (
        tabContents.length === 0 || tabButtons.length === 0 ||
        accContents.length === 0 || accButtons.length === 0
    ) {
        return;
    }

    fromEvent(tabButtons, 'click').subscribe(changeTabHandler);
    resolveInitialStateForAccordion();
};

const changeTabHandler = () => {
    qs.removeClass(accButtons, ACC_ACTIVE_CLASS);
    qs.removeClass(accContents, ACC_ACTIVE_CLASS);
};

const resolveInitialStateForAccordion = () => {
    const hashLocation = StringHelper.decodeCyrillicFromUtf8(window.location.hash.replace(/^#/, ''));

    if (hashLocation) {
        for (const element of accContents) {
            if (hashLocation === element.id) {
                qs.addClass(element, ACC_ACTIVE_CLASS);
                qs.addClass(qs.querySelector(`[data-accordion-target="#${hashLocation}"]`), ACC_ACTIVE_CLASS);

                return;
            } else if (element.id.includes(hashLocation)) {
                qs.addClass(element, ACC_ACTIVE_CLASS);
                qs.addClass(qs.querySelector(`[data-accordion-target="#${hashLocation}-1"]`), ACC_ACTIVE_CLASS);
                setWindowHashLocation(`#${hashLocation}-1`);

                return;
            }
        }
    }

    qs.addClass(accContents[0], ACC_ACTIVE_CLASS);
    qs.addClass(accButtons[0], ACC_ACTIVE_CLASS);
};
